import { general } from './general'

export const getters = Object.assign({}, general)
